import React, { Component, useState, useEffect, useContext } from "react";
import { hot } from "react-hot-loader";
import {
  Input,
  Button,
  Modal,
  Select,
  Form,
  notification,
  Icon,
  Alert
} from "antd";
const { TextArea } = Input;
import { InvitationsApi } from "../../services/generated-sdk/apis/InvitationsApi";
import CenterElement from "../common/layout/CenterElement";

import {
  Invitation,
  Project,
  ProjectsApi,
  Role,
  RolesApi,
  UsersApi
} from "../../services/generated-sdk";
import { FormCreateOption } from "antd/lib/form";
import { getEmailRegex, handleError } from "../../utils/common";
import { AppContext } from "../../AppContext";
//import EditableContent from "../common/EditableContent";
import { checkFeature } from "../../utils/planFeatureHelper";
import { Link } from "react-router-dom";
import * as _ from "lodash";
const _validateEmail = email => {
  var re = getEmailRegex();
  return re.test(String(email).toLowerCase());
};

function InviteNewUsersStatic({
  visible,
  form,
  onCancel,
  showSkip = false,
  ...props
}) {
  //console.log({ form });
  const { getFieldDecorator } = form;
  const { company, planDetails, updateUsageDetails } = useContext(AppContext);
  const API = new InvitationsApi();
  const [sendingInvite, setSendingInvite] = useState(false);
  const [usersToInvite, _setUsersToInvite] = useState<string[]>([]);
  const [invalidEmails, setInvalidEmails] = useState<string[]>([]);
  const [roles, setRoles] = useState<Role[]>([]);

  const [inputHasError, setInputHasError] = useState(false);
  const [projects, setProjects] = useState<Project[]>([]);
  const [selectedProjects, setSelectedProjects] = useState<number[]>([]);
  const [tempUserToInvite, setTempUserToInvite] = useState("");
  const [errorMessage, setErrorMessage] = useState({
    visible: false,
    title: ""
  });
  const [html, setHtml] = useState("");
  const [invitedMembers, setInvitedMembers] = useState<Invitation[]>([]);

  const clearAll = () => {
    _setUsersToInvite([]);
    setInputHasError(false);
    setTempUserToInvite("");
  };

  const onUserToInviteChange = e => {
    setTempUserToInvite(e.target.value);
    setHtml(e.target.value);
    if (inputHasError) {
      isValidEmail();
    }
  };

  useEffect(() => {
    console.log("FETCHING PROJECTS.....INVITE....");
    fetchProjects();
    fetchRoles();
  }, []);

  useEffect(
    () => {
      setErrorMessage({ visible: false, title: "" });
    },
    [visible]
  );
  useEffect(
    () => {
      let users = tempUserToInvite;
      users = users.replace(/,/g, "\n");
      _setUsersToInvite(
        users
          .split("\n")
          .map(email => email.trim())
          .filter(email => email.length > 0)
      );
    },
    [tempUserToInvite]
  );

  useEffect(
    () => {
      if (visible) {
        setInvitedMembers([]);
        // fetchInvitedMember();
      }
    },
    [visible]
  );

  const fetchProjects = async () => {
    try {
      const API = new ProjectsApi();
      const projects = await API.getProjects({
        company: company.id,
        filter: JSON.stringify({ archived_ne: 1 }),
        limit: -1
      });
      setProjects(projects);
      if (showSkip === true) {
        setSelectedProjects([projects[0].id]);
      }
    } catch (error) {
      handleError(error.status);
    }
  };

  const fetchRoles = async () => {
    try {
      const API = new RolesApi();
      const roles = await API.getRoles({ company: company.id });
      setRoles(roles);
    } catch (error) {
      handleError(error.status);
    }
  };

  // const fetchInvitedMember = async () => {
  //   try {
  //     const result = await API.getInvitations({
  //       company: company ? company.id : null,
  //     });
  //     setInvitedMembers(result);
  //   } catch (e) {
  //     handleError(e.status);
  //   }
  //   // if (result.hasOwnProperty("status") && result["status"] === false) {
  //   //   notification["error"]({
  //   //     message: "Error",
  //   //     description: result["message"]
  //   //   });
  //   // } else {
  //   // }
  // };

  const isValidEmail = () => {
    //const emails = e.target.value.split("\n");
    //console.log("validateEmail");
    let isValid = true;
    setInputHasError(false);
    setInvalidEmails([]);
    let invalidEmailList: string[] = [];
    if (tempUserToInvite.length === 0) {
      setInputHasError(true);
      isValid = false;
    } else {
      let users = tempUserToInvite;
      users = users.replace(/,/g, "\n");

      users
        .split("\n")
        .filter(eachEmail => eachEmail.length > 0)
        .forEach(email => {
          console.log({ email, valid: _validateEmail(email.trim()) });
          if (!_validateEmail(email.trim())) {
            setInputHasError(true);
            isValid = false;
            invalidEmailList.push(email.trim());
          }
        });
    }
    setInvalidEmails(invalidEmailList);
    return isValid;
  };

  const sendInvite = async (email, values = {}) => {
    try {
      await API.createInvitation({
        invitationPayload: {
          email,
          company:
            company && company.id ? company.id : _.get(props, "companyData.id"),
          ...values
        }
      });
      return true;
    } catch (e) {
      if (e.json) {
        e.json().then(data => {
          console.log({ data });
          handleError(data.statusCode, {}, data.message || "");
        });
      } else {
        console.log({ invite_user_error: e });
        notification.warn({
          message:
            e && e.message
              ? e.message
              : "Could not process your request at the moment. Please try again."
        });
      }
      return false;
    }
  };

  const sendInvites = async () => {
    //validateEmail();
    form.validateFields(async (err, values) => {
      if (!err) {
        if (isValidEmail()) {
          setSendingInvite(true);
          if (
            values.projects &&
            Array.isArray(values.projects) &&
            values.projects.length
          ) {
            if (values.role == undefined || !values.role) {
              notification.error({
                message: "Please select role"
              });
              setSendingInvite(false);
              return;
            }
          }

          let invitations = 0;
          let emails = _.uniq(
            usersToInvite.map(email => email.toLocaleLowerCase())
          );
          checkFeature({
            featureName: "users",
            planDetails,
            recordsToAdd: emails.length,
            showUpgradeModal: setErrorMessage,
            company,
            callback: async allowed => {
              if (allowed) {
                const results = await Promise.all(
                  emails.map(async email => {
                    const result = await sendInvite(email, values);

                    if (result) {
                      invitations++;
                    }
                    return result;
                  })
                );

                if (invitations === 0) {
                  // notification["error"]({
                  //   message: "Error",
                  //   description: "Something went wrong"
                  // });
                } else {
                  notification["success"]({
                    message: "Done",
                    description: `Invitation sent to ${emails.length} users`
                  });
                  handleCancel();
                  clearAll();
                  updateUsageDetails();
                }

                // const { data, headers } = await tc.post({
                //   action: `/invitations/send`,
                //   options: {
                //     body: {
                //       emails: usersToInvite
                //     }
                //   }
                // });
                setSendingInvite(false);
                clearAll();
                handleCancel(true);
              } else {
                setSendingInvite(false);
                handleCancel(true);
              }
            }
          });
        }
      } else {
        const errMsg = Object.keys(err).map(field => {
          return err[field].errors[0].message;
        });
        notification.warn({ message: errMsg.join(",") });
      }
    });
  };

  const resendInvite = async (e, inviteeId: number, email: string) => {
    e.preventDefault();

    try {
      await API.deleteInvitation({
        id: inviteeId
      });
      if (sendInvite(email)) {
        notification["success"]({
          message: "Done",
          description: `Invitation successfully re-sent to  ${email}`
        });
      }
    } catch (e) {
      handleError(e.status);
    }
    return false;
  };

  const deleteInvite = async (e, inviteId) => {
    e.preventDefault();
    try {
      const result = await API.deleteInvitation({
        id: inviteId
      });
      notification["success"]({
        message: "Done",
        description: "Invitation Canceled"
      });
    } catch (e) {
      handleError(e.status);
    }

    onCancel();
    clearAll();
    return false;
  };

  let textAreaProps = {};
  if (inputHasError) {
    const invalidEmailsString = invalidEmails
      .filter(eachEmail => eachEmail.trim().length > 0)
      .concat(", ");
    textAreaProps = {
      validateStatus: "error",
      help: `${invalidEmailsString.slice(0, invalidEmailsString.length - 1)} ${
        invalidEmails.length === 1 ? "is" : "are"
      } not ${invalidEmails.length === 1 ? "a" : ""} valid email`
    };
  }
  //console.log({ textAreaProps });
  const onPressEnter = ({ html, text }) => {
    console.log({ html, text });
    if (_validateEmail(text.trim())) {
      // setInputHasError(true);
      let newhtml = html.substr(0, html.search(text.trim));
      newhtml += `<span style="background:'#bbb'">${text}</span>`;
      console.log({ html, newhtml });
      setHtml(newhtml);
    }
  };

  const handleCancel = (waitForSubmission?) => {
    setSelectedProjects([]);
    if (waitForSubmission === true) {
      //do not skip this step as form validation is there - TCV-2493
    } else if (onCancel) {
      onCancel();
    }
    clearAll();
  };

  return (
    <div>
      <Modal
        visible={visible}
        //title={`Invite team to ${company.name}`}
        //onOk={this.handleOk}
        onCancel={handleCancel}
        // width="60%"
        destroyOnClose
        footer={null}
      >
        {/* <h2>Invited members</h2>
        <List
          bordered
          dataSource={invitedMembers}
          renderItem={invitee => (
            <List.Item>
              <List.Item.Meta
                avatar={
                  <Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />
                }
                title={<a href="https://ant.design">{invitee.email}</a>}
                //description="Sent invite at blah blah"
              />
              <div>
                {invitee.status == 0 ? (
                  <span>
                    <a
                      href="#"
                      onClick={e => resendInvite(e, invitee.id, invitee.email)}
                    >
                      Re-send Invite
                    </a>
                    <Divider type="vertical" />
                    <a href="#" onClick={e => deleteInvite(e, invitee.id)}>
                      Cancel
                    </a>
                  </span>
                ) : null}
                {invitee.status == 1 ? (
                  <span>
                    <Icon
                      type="check-circle"
                      theme="twoTone"
                      twoToneColor="#52c41a"
                    />{" "}
                    Joined
                  </span>
                ) : null}
                {invitee.status == 2 ? (
                  <span>
                    <Icon
                      type="close-circle"
                      theme="twoTone"
                      twoToneColor="red"
                    />{" "}
                    Cancelled
                  </span>
                ) : null}
              </div>
            </List.Item>
          )}
          style={{ height: 300, overflowY: "scroll" }}
        /> */}

        <CenterElement>
          <h2>
            Testing is done better in collaboration <br />
            Invite your team now!
          </h2>
        </CenterElement>
        <br />
        <br />

        {errorMessage && errorMessage.visible ? (
          <Alert
            message={
              <span>
                {errorMessage.title} <Link to="/upgrade_plan">Upgrade</Link>
              </span>
            }
            type="warning"
          />
        ) : null}

        <Form.Item label="Choose a starting Project">
          {getFieldDecorator(`projects`, {
            initialValue: selectedProjects
          })(
            <Select
              style={{ width: "100%", margin: "10px 0" }}
              placeholder="Select a project"
              mode="multiple"
              onChange={setSelectedProjects}
              value={selectedProjects}
              filterOption={(input, option) => {
                return (
                  typeof option.props.children == "string" &&
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
              }}
            >
              {projects.map(project => (
                <Select.Option
                  key={`project_key_${project.id}`}
                  value={project.id}
                >
                  {project.name}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>

        {selectedProjects && selectedProjects.length ? (
          <Form.Item label="Role">
            {getFieldDecorator(`role`, {
              rules: [{ required: true, message: "Please select role" }],
              "option.initialValue": roles[0] ? roles[0].id : null
            })(
              <Select
                style={{ width: "100%", margin: "10px 0 20px 0px" }}
                placeholder="Select role"
                defaultActiveFirstOption
                // defaultValue={roles[0].id}
                // mode=""
              >
                {roles.map(role => (
                  <Select.Option key={`role_key_${role.id}`} value={role.id}>
                    {role.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        ) : null}

        <Form.Item {...textAreaProps} label="Email addresses">
          {/* <EditableContent html={html} onChange={onUserToInviteChange} onPressEnter={onPressEnter} /> */}
          {getFieldDecorator(`emails`, {
            rules: [{ required: true, message: "Please enter email address" }]
          })(
            <TextArea
              rows={4}
              placeholder="e.g. john@mycompany.com (one email per line or comma separated emails)"
              onChange={onUserToInviteChange}
              onPressEnter={() => isValidEmail()}
              value={tempUserToInvite}
              //hasFeedback={true}
            />
          )}
        </Form.Item>
        <CenterElement>
          <Button
            key="submit"
            type="primary"
            className="btn-success"
            size="large"
            loading={sendingInvite}
            disabled={inputHasError}
            onClick={sendInvites}
            icon="mail"
          >
            Send Invite{" "}
            {usersToInvite.length > 0 ? (
              <span style={{ paddingLeft: 5 }}>({usersToInvite.length})</span>
            ) : null}
          </Button>{" "}
          {showSkip === true ? (
            <Button
              type="link"
              //className="btn-success"
              style={{ verticalAlign: "sub", color: "#8e8b8b" }}
              //icon="arrow-right"
              //size="large"
              onClick={onCancel}
            >
              Skip for now
            </Button>
          ) : null}
        </CenterElement>
      </Modal>
    </div>
  );
  //   return (

  //         <Tag
  //           closable
  //           //onClose={log}
  //           color="blue"
  //         >
  //           Tag 2
  //         </Tag>
  //         <br />
  //         <br />changeU
  //       </Modal>
  //     </div>
  //   );
}
const mapPropsToFields: FormCreateOption<any> = {};
const InviteNewUsers = Form.create(mapPropsToFields)(InviteNewUsersStatic);
export default InviteNewUsers;
